import { AnimatePresence } from 'framer-motion'

import { Anchor, ToastCard, Message, UndoButton, DismissButton } from './styled'
import { UndoToastProps } from './types'

/**
 * Bottom-centred ephemeral toast that surfaces an "Undo" affordance for
 * destructive-but-reversible actions. Driven by an external controller
 * so callers own the action semantics; this is just the chrome.
 *
 * @param {UndoToastProps} props
 * @returns {JSX.Element}
 */
const UndoToast = ({ controller }: UndoToastProps): JSX.Element => {
  return (
    <Anchor>
      <AnimatePresence>
        {controller.toast !== null ? (
          <ToastCard
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.28 } }}
            exit={{ opacity: 0, y: 24 }}
          >
            <Message>{controller.toast.message}</Message>
            <UndoButton type="button" onClick={controller.runUndo}>
              Undo
            </UndoButton>
            <DismissButton
              type="button"
              onClick={controller.dismiss}
              aria-label="Dismiss notification"
            >
              ×
            </DismissButton>
          </ToastCard>
        ) : null}
      </AnimatePresence>
    </Anchor>
  )
}

export default UndoToast
